(() => {
  const states = new WeakMap();
  function initAnnouncement(el) {
    if (states.has(el)) return;
    const slides = Array.from(el.querySelectorAll('[data-slide]'));
    if (slides.length < 2) return;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const button = el.querySelector('[data-pause]');
    let index = 0, timer, userPaused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const stop = () => { clearInterval(timer); timer = undefined; };
    const update = () => {
      button?.setAttribute('aria-pressed', String(userPaused));
      button?.setAttribute('aria-label', userPaused ? 'Play announcements' : 'Pause announcements');
      if (button) button.textContent = userPaused ? '▷' : 'Ⅱ';
    };
    const start = () => {
      stop();
      if (userPaused || document.hidden || el.matches(':hover') || el.contains(document.activeElement)) return;
      timer = setInterval(() => {
        slides[index].hidden = true;
        index = (index + 1) % slides.length;
        slides[index].hidden = false;
      }, Math.max(3000, Number(el.dataset.speed) || 5000));
    };
    button?.addEventListener('click', () => { userPaused = !userPaused; update(); start(); }, options);
    el.addEventListener('mouseenter', stop, options);
    el.addEventListener('mouseleave', start, options);
    el.addEventListener('focusin', stop, options);
    el.addEventListener('focusout', () => setTimeout(start, 0), options);
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start(), options);
    update(); start();
    states.set(el, () => { stop(); controller.abort(); });
  }
  function initProduct(el) {
    if (states.has(el)) return;
    const select = el.querySelector('[data-variant]');
    if (!select) return;
    const controller = new AbortController();
    const variants = JSON.parse(el.querySelector('[data-variants]').textContent);
    const price = el.querySelector('[data-price]'), add = el.querySelector('[data-add]'), quantity = el.querySelector('[data-quantity]');
    const change = () => {
      const v = variants.find(v => String(v.id) === select.value);
      if (!v) return;
      price.textContent = v.price;
      if (v.has_compare) { const s = document.createElement('s'); s.textContent = v.compare; price.append(' ', s); }
      add.disabled = !v.available;
      add.textContent = v.available ? 'Add to bag' : 'Sold out';
      quantity.min = v.min || 1; quantity.step = v.step || 1;
      if (v.max != null) quantity.max = v.max; else quantity.removeAttribute('max');
      quantity.value = v.min || 1;
      const accelerated = el.querySelector('[data-dynamic-checkout]');
      if (accelerated) accelerated.hidden = !v.available;
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    };
    select.addEventListener('change', change, { signal: controller.signal });
    states.set(el, () => controller.abort());
  }
  function init(root) {
    root.querySelectorAll('[data-announcement]').forEach(initAnnouncement);
    root.querySelectorAll('[data-product-root]').forEach(initProduct);
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-announcement], [data-product-root]').forEach(el => { states.get(el)?.(); states.delete(el); });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.header details[open]').forEach(el => el.open = false);
  });
})();
